import moment from 'moment';

export function isOutOfOrder(state) {
  let outOfOrder;
  const currentRouteOrder = assignOrderToRoute(window.location.pathname);
  if (currentRouteOrder !== -1) {
    outOfOrder = currentRouteOrder > state.highestPageHit.value + 1;
  } else {
    outOfOrder = true;
  }
  return outOfOrder;
}

export function assignOrderToRoute(location) {
  const basepath = window.pathBaseName;
  if (location === `${basepath}/` || location === basepath || location === `${basepath}/apply` || noRouteOrder(location, basepath)) {
    return 1;
  }
  if (location === `${basepath}/review`) {
    return 2;
  }
  if (location === `${basepath}/offer-loading`) {
    return 3;
  }
  if (location === `${basepath}/review-offer`) {
    return 4;
  }
  return -1;
}

export function noRouteOrder(location, basepath) {
  return (
    location === `${basepath}/dealer-connect` ||
    location === `${basepath}/send-to-dealer` ||
    location === `${basepath}/dealer-confirmation` ||
    location === `${basepath}/dealer-submission` ||
    location === `${basepath}/error` ||
    location === `${basepath}/terms-and-conditions` ||
    location === `${basepath}/maintenance` ||
    location === `${basepath}/landing-page`
  );
}

export function currencyFormat(num) {
  return `$${num.toString().replace(/(\d)(?=(\d{3})+?(?!\d))/g, '$1,')}`;
}

export function dateFormat(date) {
  return moment(date).format('MMMM DD, Y');
}

export function timeFormat(date) {
  let formatDate = moment(date, 'h:m a');
  formatDate = formatDate.format('LT');
  formatDate = formatDate.toString();
  const newDate = formatDate.split(' ')[0];
  let newTime;
  if (newDate.split(':')[1] === '00') {
    newTime = newDate.split(':')[0];
  } else {
    newTime = newDate;
  }
  if (formatDate.includes('PM')) {
    newTime += ' p.m.';
  } else {
    newTime += ' a.m.';
  }

  return newTime;
}

export function decodeBase64ToJson(encodedString){
  if (isBase64(encodedString)){
    const decodedString = atob(encodedString);
    return JSON.parse(decodedString);
  }
  return encodedString;
}

export function isBase64(str) {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
}